












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TimeField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop(String) public readonly labelCols!: string;
  @Prop(String) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

  public hours = '';
  public minutes = '';

  public saveTime() {
    // Check if input is valid
    const validHours = this.isValidHours(this.hours);
    const validMinutes = this.isValidMinutes(this.minutes);
    // Format valid inputs and remove invalid inputs
    this.hours = validHours ? this.formatNumber(this.hours) : '';
    this.minutes = validMinutes ? this.formatNumber(this.minutes) : '';
    if (validHours && this.minutes === '') {
      this.minutes = '00';
    }
    if (!validHours) {
      // Reset time and empty minutes field
      this.minutes = '';
      this.rec[this.field] = null;
    } else if (!validMinutes) {
      // Reset time and set default minutes field
      this.minutes = '00';
      this.rec[this.field] = this.hours + ':' + this.minutes + ':00';
    } else {
      // Save time
      this.rec[this.field] = this.hours + ':' + this.minutes + ':00';
    }
  }

  // Return true if the input is a valid number of hours
  public isValidHours(h) {
    if (h.length === 1 || h.length === 2) {
      return this.parseNumber(h) < 24;
    } else {
      return false;
    }
  }

  // Return true if the input is a valid number of minutes
  public isValidMinutes(m) {
    if (m.length === 1 || m.length === 2) {
      return this.parseNumber(m) < 60;
    } else {
      return false;
    }
  }

  // Add leading zero if the number has only one digit
  public formatNumber(n) {
    return n.length === 1 ? '0' + n : n;
  }

  // Parse string to valid number, remove leading zeros
  public parseNumber(n) {
    return Number(n.replace(/^0+/, ''));
  }

  @Watch('rec') public timeChanged(value: string, oldValue: string) {
    if (this.rec[this.field]) {
      this.hours = this.rec[this.field].split(':')[0];
      this.minutes = this.rec[this.field].split(':')[1];
      // const seconds = this.rec[this.field].split(':')[2]
    }
  }
}
